
import Utils from "@/common/util.js";
export default [
  {
    path: "/futures",
    name: "invite",
		redirect: '/futures/invite-friends',
		component: () => import('@/layout/index'),
    children: [
      {
        path: 'invite-friends',
        component: () => import('@/pages/v2/invite/index')
      }
    ],
  },
  {
    path: "/futures/register",
    name: "register",
    component: () => {
      const {pcStatus, h5Status} = JSON.parse(sessionStorage.getItem('register_switch'))
      if (Utils.isMobile()) {
        if (h5Status == '1') {
          return import('@/pages/v2/h5/home')
        } else {
          return import('@/pages/v2/invite/register')
        }
      } else {
        if (pcStatus == '1') {
          return import('@/pages/v2/home')
        } else {
          return import('@/pages/v2/register')
        }
      }
    }
  },
  {
    path: "/registers/:lang",
    name: "register",
    component: () => {
      const {pcStatus, h5Status} = JSON.parse(sessionStorage.getItem('register_switch'))
      if (Utils.isMobile()) {
        if (h5Status == '1') {
          return import('@/pages/v2/h5/home')
        } else {
          return import('@/pages/v2/invite/register')
        }
      } else {
        if (pcStatus == '1') {
          return import('@/pages/v2/home')
        } else {
          return import('@/pages/v2/register')
        }
      }
    }
  },
  {
    path: "/futures/h5-home",
    name: "h5-home",
    component: () => import('@/pages/v2/invite/home'),
  }
]


// WEBPACK FOOTER //
// ./src/router/v2/invite/index.js